import { ReactNode, useRef, useState } from "react";
import { View, StyleSheet, LayoutChangeEvent } from "react-native";
import Svg, { Defs, LinearGradient, Stop, Rect } from "react-native-svg";
import { useThemeSettings } from "../ThemeProvider";

interface StrokeProps {
    children: ReactNode;
    wrapperStyle?: any;
    style?: any;
    stroke?: number;
}

export function GradientStrokeBox({
    children,
    wrapperStyle,
    style,
    stroke = 4,
}: StrokeProps) {
    const gradientId = useRef(`BorderGradient-${Date.now()}`).current;
    const { theme } = useThemeSettings();

    const [size, setSize] = useState({ width: 0, height: 0 });

    const onLayout = (e: LayoutChangeEvent) => {
        const { width, height } = e.nativeEvent.layout;
        setSize({ width, height });
    };

    const borderRadius = wrapperStyle?.borderRadius ?? 35;

    return (
        <View
            onLayout={onLayout}
            style={[
                styles.wrapper,
                wrapperStyle,
                { borderRadius },
            ]}
        >
            {size.width > 0 && size.height > 0 && (
                <Svg
                    pointerEvents="none"
                    width="100%"
                    height="100%"
                    viewBox={`0 0 ${size.width} ${size.height}`}
                    preserveAspectRatio="none"
                    style={StyleSheet.absoluteFill}
                >
                    <Defs>
                        <LinearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
                            <Stop offset="20%" stopColor={"#8F3E47"} />
                            <Stop offset="60%" stopColor="#F2BB05" />
                            <Stop offset="90%" stopColor="#A65301" />
                        </LinearGradient>
                    </Defs>

                    <Rect
                        x={stroke / 2}
                        y={stroke / 2}
                        width={size.width - stroke}
                        height={size.height - stroke}
                        rx={borderRadius - stroke / 2}
                        ry={borderRadius - stroke / 2}
                        fill="none"
                        stroke={`url(#${gradientId})`}
                        strokeWidth={stroke}
                    />
                </Svg>
            )}

            <View
                style={[
                    styles.content,
                    {
                        borderRadius,
                        padding: stroke - 1,
                    },
                    style,
                ]}
            >
                {children}
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    wrapper: {
        position: "relative",
    },
    content: {
        backgroundColor: "transparent",
        flexDirection: "row",
        flex: 1,
    },
});
